export interface TailwindClassGroup {
  category: string;
  classes: string[];
}

export const tailwindClasses: TailwindClassGroup[] = [
  {
    category: "Text Color",
    classes: [
      "text-red-500",
      "text-red-600",
      "text-red-700",
      "text-blue-500",
      "text-blue-600",
      "text-blue-700",
      "text-green-500",
      "text-green-600",
      "text-green-700",
      "text-yellow-500",
      "text-yellow-600",
      "text-yellow-700",
      "text-purple-500",
      "text-purple-600",
      "text-purple-700",
      "text-pink-500",
      "text-pink-600",
      "text-pink-700",
      "text-indigo-500",
      "text-indigo-600",
      "text-indigo-700",
      "text-gray-500",
      "text-gray-600",
      "text-gray-700",
      "text-gray-800",
      "text-gray-900",
      "text-white",
      "text-black",
    ],
  },
  {
    category: "Background Color",
    classes: [
      "bg-red-50",
      "bg-red-100",
      "bg-red-200",
      "bg-red-500",
      "bg-blue-50",
      "bg-blue-100",
      "bg-blue-200",
      "bg-blue-500",
      "bg-green-50",
      "bg-green-100",
      "bg-green-200",
      "bg-green-500",
      "bg-yellow-50",
      "bg-yellow-100",
      "bg-yellow-200",
      "bg-yellow-500",
      "bg-purple-50",
      "bg-purple-100",
      "bg-purple-200",
      "bg-purple-500",
      "bg-pink-50",
      "bg-pink-100",
      "bg-pink-200",
      "bg-pink-500",
      "bg-indigo-50",
      "bg-indigo-100",
      "bg-indigo-200",
      "bg-indigo-500",
      "bg-gray-50",
      "bg-gray-100",
      "bg-gray-200",
      "bg-gray-500",
      "bg-white",
      "bg-black",
      "bg-transparent",
    ],
  },
  {
    category: "Font Size",
    classes: [
      "text-xs",
      "text-sm",
      "text-base",
      "text-lg",
      "text-xl",
      "text-2xl",
      "text-3xl",
      "text-4xl",
      "text-5xl",
      "text-6xl",
      "text-7xl",
      "text-8xl",
      "text-9xl",
    ],
  },
  {
    category: "Font Weight",
    classes: [
      "font-thin",
      "font-extralight",
      "font-light",
      "font-normal",
      "font-medium",
      "font-semibold",
      "font-bold",
      "font-extrabold",
      "font-black",
    ],
  },
  {
    category: "Text Decoration",
    classes: [
      "underline",
      "overline",
      "line-through",
      "no-underline",
      "decoration-solid",
      "decoration-double",
      "decoration-dotted",
      "decoration-dashed",
      "decoration-wavy",
      "underline-offset-1",
      "underline-offset-2",
      "underline-offset-4",
      "underline-offset-8",
    ],
  },
  {
    category: "Text Alignment",
    classes: [
      "text-left",
      "text-center",
      "text-right",
      "text-justify",
      "text-start",
      "text-end",
    ],
  },
  {
    category: "Text Transform",
    classes: [
      "uppercase",
      "lowercase",
      "capitalize",
      "normal-case",
    ],
  },
  {
    category: "Padding",
    classes: [
      "p-0",
      "p-1",
      "p-2",
      "p-3",
      "p-4",
      "p-5",
      "p-6",
      "p-8",
      "p-10",
      "p-12",
      "px-1",
      "px-2",
      "px-3",
      "px-4",
      "px-6",
      "px-8",
      "py-1",
      "py-2",
      "py-3",
      "py-4",
      "py-6",
      "py-8",
      "pt-1",
      "pt-2",
      "pt-4",
      "pt-6",
      "pt-8",
      "pb-1",
      "pb-2",
      "pb-4",
      "pb-6",
      "pb-8",
      "pl-1",
      "pl-2",
      "pl-4",
      "pl-6",
      "pl-8",
      "pr-1",
      "pr-2",
      "pr-4",
      "pr-6",
      "pr-8",
    ],
  },
  {
    category: "Margin",
    classes: [
      "m-0",
      "m-1",
      "m-2",
      "m-3",
      "m-4",
      "m-5",
      "m-6",
      "m-8",
      "m-10",
      "m-12",
      "mx-1",
      "mx-2",
      "mx-3",
      "mx-4",
      "mx-6",
      "mx-8",
      "mx-auto",
      "my-1",
      "my-2",
      "my-3",
      "my-4",
      "my-6",
      "my-8",
      "mt-1",
      "mt-2",
      "mt-4",
      "mt-6",
      "mt-8",
      "mb-1",
      "mb-2",
      "mb-4",
      "mb-6",
      "mb-8",
      "ml-1",
      "ml-2",
      "ml-4",
      "ml-6",
      "ml-8",
      "mr-1",
      "mr-2",
      "mr-4",
      "mr-6",
      "mr-8",
    ],
  },
  {
    category: "Border",
    classes: [
      "border",
      "border-0",
      "border-2",
      "border-4",
      "border-8",
      "border-t",
      "border-b",
      "border-l",
      "border-r",
      "border-solid",
      "border-dashed",
      "border-dotted",
      "border-double",
      "border-none",
    ],
  },
  {
    category: "Border Color",
    classes: [
      "border-red-500",
      "border-blue-500",
      "border-green-500",
      "border-yellow-500",
      "border-purple-500",
      "border-pink-500",
      "border-indigo-500",
      "border-gray-200",
      "border-gray-300",
      "border-gray-400",
      "border-gray-500",
      "border-white",
      "border-black",
      "border-transparent",
    ],
  },
  {
    category: "Border Radius",
    classes: [
      "rounded-none",
      "rounded-sm",
      "rounded",
      "rounded-md",
      "rounded-lg",
      "rounded-xl",
      "rounded-2xl",
      "rounded-3xl",
      "rounded-full",
      "rounded-t-lg",
      "rounded-b-lg",
      "rounded-l-lg",
      "rounded-r-lg",
    ],
  },
  {
    category: "Shadow",
    classes: [
      "shadow-none",
      "shadow-sm",
      "shadow",
      "shadow-md",
      "shadow-lg",
      "shadow-xl",
      "shadow-2xl",
      "shadow-inner",
    ],
  },
  {
    category: "Opacity",
    classes: [
      "opacity-0",
      "opacity-5",
      "opacity-10",
      "opacity-20",
      "opacity-25",
      "opacity-30",
      "opacity-40",
      "opacity-50",
      "opacity-60",
      "opacity-70",
      "opacity-75",
      "opacity-80",
      "opacity-90",
      "opacity-95",
      "opacity-100",
    ],
  },
  {
    category: "Width",
    classes: [
      "w-auto",
      "w-full",
      "w-screen",
      "w-min",
      "w-max",
      "w-fit",
      "w-1/2",
      "w-1/3",
      "w-2/3",
      "w-1/4",
      "w-3/4",
      "w-1/5",
      "w-2/5",
      "w-3/5",
      "w-4/5",
      "w-32",
      "w-40",
      "w-48",
      "w-56",
      "w-64",
      "w-72",
      "w-80",
      "w-96",
    ],
  },
  {
    category: "Height",
    classes: [
      "h-auto",
      "h-full",
      "h-screen",
      "h-min",
      "h-max",
      "h-fit",
      "h-32",
      "h-40",
      "h-48",
      "h-56",
      "h-64",
      "h-72",
      "h-80",
      "h-96",
    ],
  },
  {
    category: "Display",
    classes: [
      "block",
      "inline-block",
      "inline",
      "flex",
      "inline-flex",
      "grid",
      "inline-grid",
      "hidden",
    ],
  },
  {
    category: "Flex",
    classes: [
      "flex-row",
      "flex-row-reverse",
      "flex-col",
      "flex-col-reverse",
      "flex-wrap",
      "flex-wrap-reverse",
      "flex-nowrap",
      "flex-1",
      "flex-auto",
      "flex-initial",
      "flex-none",
    ],
  },
  {
    category: "Justify Content",
    classes: [
      "justify-start",
      "justify-end",
      "justify-center",
      "justify-between",
      "justify-around",
      "justify-evenly",
    ],
  },
  {
    category: "Align Items",
    classes: [
      "items-start",
      "items-end",
      "items-center",
      "items-baseline",
      "items-stretch",
    ],
  },
  {
    category: "Gap",
    classes: [
      "gap-0",
      "gap-1",
      "gap-2",
      "gap-3",
      "gap-4",
      "gap-5",
      "gap-6",
      "gap-8",
      "gap-10",
      "gap-12",
      "gap-x-1",
      "gap-x-2",
      "gap-x-4",
      "gap-x-6",
      "gap-y-1",
      "gap-y-2",
      "gap-y-4",
      "gap-y-6",
    ],
  },
  {
    category: "Position",
    classes: [
      "static",
      "fixed",
      "absolute",
      "relative",
      "sticky",
    ],
  },
  {
    category: "Z-Index",
    classes: [
      "z-0",
      "z-10",
      "z-20",
      "z-30",
      "z-40",
      "z-50",
      "z-auto",
    ],
  },
  {
    category: "Overflow",
    classes: [
      "overflow-auto",
      "overflow-hidden",
      "overflow-visible",
      "overflow-scroll",
      "overflow-x-auto",
      "overflow-y-auto",
      "overflow-x-hidden",
      "overflow-y-hidden",
    ],
  },
  {
    category: "Cursor",
    classes: [
      "cursor-auto",
      "cursor-default",
      "cursor-pointer",
      "cursor-wait",
      "cursor-text",
      "cursor-move",
      "cursor-help",
      "cursor-not-allowed",
    ],
  },
  {
    category: "User Select",
    classes: [
      "select-none",
      "select-text",
      "select-all",
      "select-auto",
    ],
  },
  {
    category: "Transitions",
    classes: [
      "transition-none",
      "transition-all",
      "transition",
      "transition-colors",
      "transition-opacity",
      "transition-shadow",
      "transition-transform",
      "duration-75",
      "duration-100",
      "duration-150",
      "duration-200",
      "duration-300",
      "duration-500",
      "duration-700",
      "duration-1000",
      "ease-linear",
      "ease-in",
      "ease-out",
      "ease-in-out",
    ],
  },
  {
    category: "Transform",
    classes: [
      "scale-0",
      "scale-50",
      "scale-75",
      "scale-90",
      "scale-95",
      "scale-100",
      "scale-105",
      "scale-110",
      "scale-125",
      "scale-150",
      "rotate-0",
      "rotate-45",
      "rotate-90",
      "rotate-180",
      "-rotate-45",
      "-rotate-90",
      "-rotate-180",
      "skew-x-3",
      "skew-x-6",
      "skew-x-12",
      "skew-y-3",
      "skew-y-6",
      "skew-y-12",
    ],
  },
  {
    category: "Gradient",
    classes: [
      "bg-gradient-to-t",
      "bg-gradient-to-tr",
      "bg-gradient-to-r",
      "bg-gradient-to-br",
      "bg-gradient-to-b",
      "bg-gradient-to-bl",
      "bg-gradient-to-l",
      "bg-gradient-to-tl",
      "from-red-500",
      "from-blue-500",
      "from-green-500",
      "from-yellow-500",
      "from-purple-500",
      "via-red-500",
      "via-blue-500",
      "via-green-500",
      "to-red-500",
      "to-blue-500",
      "to-green-500",
      "to-yellow-500",
      "to-purple-500",
    ],
  },
  {
    category: "Letter Spacing",
    classes: [
      "tracking-tighter",
      "tracking-tight",
      "tracking-normal",
      "tracking-wide",
      "tracking-wider",
      "tracking-widest",
    ],
  },
  {
    category: "Line Height",
    classes: [
      "leading-none",
      "leading-tight",
      "leading-snug",
      "leading-normal",
      "leading-relaxed",
      "leading-loose",
      "leading-3",
      "leading-4",
      "leading-5",
      "leading-6",
      "leading-7",
      "leading-8",
      "leading-9",
      "leading-10",
    ],
  },
  {
    category: "List Style",
    classes: [
      "list-none",
      "list-disc",
      "list-decimal",
      "list-inside",
      "list-outside",
    ],
  },
  {
    category: "Whitespace",
    classes: [
      "whitespace-normal",
      "whitespace-nowrap",
      "whitespace-pre",
      "whitespace-pre-line",
      "whitespace-pre-wrap",
    ],
  },
  {
    category: "Word Break",
    classes: [
      "break-normal",
      "break-words",
      "break-all",
      "truncate",
    ],
  },
];

/**
 * Get popular/frequently used classes for quick access
 */
export const popularClasses = [
  "text-red-500",
  "text-blue-500",
  "text-green-500",
  "bg-yellow-100",
  "bg-blue-100",
  "bg-green-100",
  "font-bold",
  "font-semibold",
  "underline",
  "text-2xl",
  "text-xl",
  "opacity-50",
  "rounded-lg",
  "shadow-md",
  "p-4",
  "m-4",
  "border",
  "flex",
  "grid",
  "text-center",
];

/**
 * Search classes by keyword
 */
export function searchTailwindClasses(query: string): string[] {
  const lowerQuery = query.toLowerCase();
  const results: string[] = [];

  tailwindClasses.forEach((group) => {
    group.classes.forEach((className) => {
      if (className.toLowerCase().includes(lowerQuery)) {
        results.push(className);
      }
    });
  });

  return results;
}

/**
 * Get all classes as a flat array
 */
export function getAllClasses(): string[] {
  return tailwindClasses.flatMap((group) => group.classes);
}


